import { z } from 'zod';
import { DraftDocumentRecordSchema } from '../base/draftDocument.js';
import { DocumatorServiceEventBaseSchema, documatorServiceEventType } from './service.js';
export const draftDocumentEventType = (eventName) => documatorServiceEventType('draftDocument', eventName);
export const DraftDocumentEventSchema = DocumatorServiceEventBaseSchema.merge(z.object({
    type: draftDocumentEventType(),
    draftDocument: DraftDocumentRecordSchema.and(z.unknown()),
}));
export const DraftDocumentCompletedEventSchema = DraftDocumentEventSchema.merge(z.object({
    type: draftDocumentEventType('completed'),
}));
